<template>
  <a-modal :title="title"
           :width="width"
           :visible="visible"
           :confirmLoading="confirmLoading"
           @ok="handleOk"
           @cancel="handleCancel"
           :destroyOnClose="true"
           :cancelText="$t('button.close')">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <mtc-form-item label="label.parentNode" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-tree-select ref="treeSelect"
                         :placeholder="$t('label.pleaseSelectParentNode')"
                         v-decorator="['pid', validatorRules.pid]"
                         dict="sys_category,name,id"
                         pidField="pid"
                         pidValue="0">
          </j-tree-select>
        </mtc-form-item>
        <mtc-form-item label="label.categoryName" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['name', validatorRules.name]"
                   :read-only="checkField('name')"
                   @click="openLangModal('name', true)"
                   :placeholder="$t('label.pleaseInputCategoryName')" />
        </mtc-form-item>
        <!--<a-form-item label="类型编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'code', validatorRules.code]" placeholder="请输入类型编码"></a-input>
        </a-form-item>-->
        <!--<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol">
          <span style="font-size: 12px;color:red" slot="label">编码规则(注)</span>
          <span style="font-size: 12px;color:red">
            编码值前缀需和父节点保持一致,比如父级节点编码是A01则当前编码必须以A01开头
          </span>
        </a-form-item>-->
      </a-form>
    </a-spin>
    <mtc-lang-modal />
  </a-modal>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import pick from 'lodash.pick'
import JTreeSelect from '@/components/jeecg/JTreeSelect'
import { mtcLangModalMixin } from '@/mixins/mtcLangModalMixin'
import langInputMixin from '@/mixins/langInputMixin'
import { resetLangFieldMap, setLangInputParams } from '@/utils/langUtils'
import { MTC_AUTH } from '@api/servers'

export default {
  name: 'SysCategoryModal',
  mixins: [mtcLangModalMixin, langInputMixin],
  components: {
    JTreeSelect
  },
  data() {
    return {
      // form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {
        // code: {
        //   rules: [
        //     {
        //       required: true,
        //       message: '请输入类型编码!',
        //     },
        //     {
        //       validator: this.validateMyCode,
        //     },
        //   ],
        // },
        pid: {},
        name: { rules: [{ required: true, message: this.$t('label.pleaseInputCategoryName') }] }
      },
      url: {
        add: `${MTC_AUTH}sys/category/add`,
        edit: `${MTC_AUTH}sys/category/edit`,
        checkCode: `${MTC_AUTH}sys/category/checkCode`
      },
      expandedRowKeys: [],
      pidField: 'pid',
      subExpandedKeys: [],
      mainTable: 'sys_category'
    }
  },
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.getLangForm(this.mainTable)
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'pid', 'name', 'code'))
        this.$bus.$emit('mainlanguageLists', record.sysLanguageList)
      })
    },
    getLangItem() {
      if (this.mainTable) {
        let _mainRequest = {
          relTable: this.mainTable
        }
        getAction(_mainRequest).then(res => {
          // validFlag
          let records = []
          res.result && res.result.map(item => {
            if (item.validFlag == 'Y') {
              records.push(item)
            }
          })
          this.mainLangItems = records

          this.mainTableLangLists = {}

          let mainTableLangLists = this.mainTableAllLangLists || []

          this.mainLangItems.forEach(item => {
            this.mainTableLangLists[ item.relEntityAttribute ] = []
          })
          for (let key in this.mainTableLangLists) {
            for (let i = 0; i < mainTableLangLists.length; i++) {
              if (key == mainTableLangLists[ i ].relEntityAttribute && this.model.id == mainTableLangLists[ i ].relBizId) {
                this.mainTableLangLists[ key ].push(mainTableLangLists[ i ])
              }
            }
          }
          console.log('%c [ this.mainTableLangLists ]', 'font-size:13px; background:pink; color:#bf2c9f;', this.mainTableLangLists)
        })
      }
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          let formData = Object.assign(this.model, values)
          // 设置数据多语言参数
          formData.sysLanguageList = setLangInputParams(this.mainTable, formData.id)
          console.log('表单提交数据', formData)
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                resetLangFieldMap()
                that.$message.success(res.message)
                that.submitSuccess(formData)
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
    handleCancel() {
      this.close()
    },
    popupCallback(row) {
      this.form.setFieldsValue(pick(row, 'pid', 'name', 'code'))
    },
    submitSuccess(formData) {
      if (!formData.id) {
        let treeData = this.$refs.treeSelect.getCurrTreeData()
        this.expandedRowKeys = []
        this.getExpandKeysByPid(formData[ this.pidField ], treeData, treeData)
        if (formData.pid && this.expandedRowKeys.length == 0) {
          this.expandedRowKeys = this.subExpandedKeys
        }
        this.$emit('ok', formData, this.expandedRowKeys.reverse())
      } else {
        this.$emit('ok', formData)
      }
    },
    getExpandKeysByPid(pid, arr, all) {
      if (pid && arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[ i ].key == pid) {
            this.expandedRowKeys.push(arr[ i ].key)
            this.getExpandKeysByPid(arr[ i ][ 'parentId' ], all, all)
          } else {
            this.getExpandKeysByPid(pid, arr[ i ].children, all)
          }
        }
      }
    },
    validateMyCode(rule, value, callback) {
      let params = {
        pid: this.form.getFieldValue('pid'),
        code: value
      }
      getAction(this.url.checkCode, params).then((res) => {
        if (res.success) {
          callback()
        } else {
          callback(res.message)
        }
      })
    }
  }
}
</script>